import { render, staticRenderFns } from "./DocumentPrint5.vue?vue&type=template&id=a381804a&scoped=true"
import script from "./DocumentPrint5.vue?vue&type=script&lang=js"
export * from "./DocumentPrint5.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrint5.vue?vue&type=style&index=0&id=a381804a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a381804a",
  null
  
)

export default component.exports